import { i18next } from '@frontend/i18n';

export const SCHEDULE_TRAINING_TASK_ID = 17;

export const Schedule1On1TrainingData = {
  title: i18next.t('Schedule 1:1 Training', { ns: 'scheduleTraining' }),
  description: i18next.t(
    '1:1 Training sessions are included in your Bundle. Get the most out of Weave by scheduling now!',
    { ns: 'scheduleTraining' }
  ),
  actionLink: 'https://calendly.com/weave-one-on-one-trainings/ultimate-bundle-training',
};

export const TrainingUnscheduledReasons = [
  {
    value: 'something-went-wrong',
    label: i18next.t('Something went wrong', { ns: 'scheduleTraining' }),
    trackingId: 'unschedule-reason-something-went-wrong',
  },
  {
    value: 'not-available',
    label: i18next.t('There were no times when I was available', { ns: 'scheduleTraining' }),
    trackingId: 'unschedule-reason-not-available',
  },
  {
    value: 'changed-my-mind',
    label: i18next.t('I changed my mind', { ns: 'scheduleTraining' }),
    trackingId: 'unschedule-reason-changed-my-mind',
  },
];
